<template>
  <div class="swper">
    <el-carousel trigger="click" :height="height" class="pc">
      <el-carousel-item>
        <img v-lazy="src1">
      </el-carousel-item>
      <el-carousel-item class="banner">
        <img v-lazy="src2">
      </el-carousel-item>
      <div class="btn">
        <el-button type="warning" @click="handleContact">联系我们</el-button>
      </div>
    </el-carousel>
    <el-carousel trigger="click" :height="mheight" class="mobile">
      <el-carousel-item>
        <img v-lazy="src3">
      </el-carousel-item>
      <el-carousel-item>
        <img v-lazy="src4">
      </el-carousel-item>
      <div class="btn">
        <el-button type="warning" @click="handleContact">联系我们</el-button>
      </div>
    </el-carousel>
  </div>
  <!-- </div> -->
</template>

<script>
import { constants } from "fs";
export default {
  name: "Swper",
  data() {
    return {
      height: "",
      mheight: "",
      src1:require('@/assets/images/banner1.jpg'),
       src2:require('@/assets/images/banner-pc.jpg'),
       src3:require('@/assets/images/banner-mb1.jpg'),
       src4:require('@/assets/images/banner-mb2.jpg'),
    };
  },
  methods: {
    handleContact() {
      this.$router.push({ path: "/contact" });
    },
    getheight() {
     
    }
  },
  beforeMount() {
     this.height = ($(window).width() * 572) / 1920 + "px";
      this.mheight = ($(window).width() * 500) / 1242 + "px";
  }
};
</script>

<style lang="scss" scoped>
.mobile {
  display: none;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
}
.el-carousel {
  img {
    width: 100%;
    height: auto;
  }
}
.btn {
  position: relative;
  z-index: 4;
  text-align: center;
  top: 80%;
  .el-button {
    color: #333;
    font-size: 16px;
    padding: 12px 20px;
  }
}
// .el-carousel__item:nth-child(2n) {
//   background-image: url("~@/assets/images/banner-pc.jpg");
//   background-position: center;
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   width: 100%;
//   height: 100%;
// }
// .el-carousel__item:nth-child(2n + 1) {
//   background-image: url("~@/assets/images/banner1.jpg");
//   background-position: center;
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   width: 100%;
//   height: 100%;
// }

@media screen and (max-width: 768px) {
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
  .btn {
    top: 70%;
    .el-button {
      font-size: 12px;
      padding: 6px 12px;
    }
  }
  // .el-carousel__item:nth-child(2n) {
  //   background-image: url("~@/assets/images/banner-mb2.jpg");
  //   background-size: 100% 100%;
  // }
  // .el-carousel__item:nth-child(2n + 1) {
  //   background-image: url("~@/assets/images/banner-mb1.jpg");
  //   background-size: 100% 100%;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/technology/swper.vue